export const PageText = {
  _1: 'What air quality information can I get out of aircheckr?',
  _2: 'Besides the aircheckr AQI, recommendations and AQ Comparison, you can get much more information out of aircheckr. All you need to do is inform your customers.'
};

export const Categories = {
  _1: {
    title: 'Extensive information',
    subcategories: [
      {
        key: 0,
        subtitle: 'Air Quality Index',
        text: 'The aircheckr AQI gives a health-based and absolute indication of the air quality. You can choose the AQI rated at 3, 10 or 100.'
      },
      {
        key: 1,
        subtitle: 'AQ Comparison',
        text: 'Air Quality Comparison gives an idea on how good the air is at this specific location compared with the air you can normally find here.'
      },
      {
        key: 2,
        subtitle: 'Recommendations',
        text: 'Based on the aircheckr air quality index, health-based recommendations are formulated. They are differentiated according to sensitivity group and application.'
      },
      {
        key: 3,
        subtitle: 'Main pollutant(s)',
        text: 'What are the main pollutants responsible for the current air quality index.'
      },
      {
        key: 4,
        subtitle: 'Source information',
        text: 'We give you specific information about the possible source of the main pollutant.'
      },
      {
        key: 5,
        subtitle: 'Help (hints)',
        text: 'As many small acts add up to a big difference, get hints from aircheckr to provide your customers with tools to take actions themselves.'
      },
      {
        key: 6,
        subtitle: 'Concentrations of individual pollutants',
        text: 'Interested in the actual concentrations of the individual pollutants? We provide them in µg/m<sup>3</sup>.'
      }
    ]
  },
  _2: {
    title: 'Past, present & future',
    subcategories: [
      {
        key: 0,
        subtitle: 'Real-time hourly or daily AQ data',
        text: 'Get the AQ right now. Aircheckr gives the current AQ info for your requested location. The hourly value is the default output of the API, but you can also get the mean for today.'
      },
      {
        key: 1,
        subtitle: 'Past hourly and daily AQ data',
        text: 'Interested to know how the air was yesterday at 17h00? Just request the API for hourly or daily data up to yesterday.'
      },
      {
        key: 2,
        subtitle: 'Forecasted hourly & daily AQ data',
        text: 'aircheckr can predict the air quality in the future. Give in the time of interest (timestamp) and you will get the predicted air quality info for e.g. the next hour or for tomorrow. It can be hourly data (for the next 24 hours) or daily (tomorrow and the day after tomorrow).',
        text_2: 'Check “<a href="https://aircheckr.com/products#portfolio">our current portfolio</a>” section to get the latest view on what aircheckr products are available and where.'
      }
    ]
  },
  _3: {
    title: 'There is more',
    subcategories: [
      {
        key: 0,
        subtitle: 'Statistics',
        text: 'Besides hourly and daily AQ data, aircheckr also provides statistics and information on what air quality means in the long term. For more info, check the <a href="/help-and-guides/what-with-long-term-effect">statistics section</a>.'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/what-air-quality-info-can-i-get_page.js